<bn-loading-overlay></bn-loading-overlay>
<ng-template #carregando>
    <div class="loading-pesquisa"><i class="bn-loading"></i></div>
</ng-template>

<div class="container" *ngIf="janelaEnvioAtual; else carregando">
    <div class="row">
        <div class="col">
            <h3>Solicitação de honra</h3>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-danger" bnConfirm tituloConfirm="Confirmação" msgConfirm="Excluir todas as solicitações de honra da janela atual?" (onConfirm)="excluiTodas ()" *ngIf="solicitacoesHonra && solicitacoesHonra.length">Excluir Todas</button>
            <button type="button" class="btn btn-primary" (click)="voltarParaLista ()">Voltar</button>
        </div>
    </div>
    <div class="row" >
        <div class="col-md-4">
            <p>Abertura da janela: {{janelaEnvioAtual.dataAbertura| date:'dd/MM/yyyy'}}. <br>
            Fechamento da janela: {{janelaEnvioAtual.dataFechamento| date:'dd/MM/yyyy'}}.</p>
        </div>
        <div class="col-md-8" *ngIf="mensagemAlerta">
            <p class="color-red"><i class="fas fa-exclamation-triangle color-red"></i> {{mensagemAlerta}}</p>
        </div>
    </div>
</div>

<div class="container" *ngIf="janelaEnvioAberta">
    <div class="row">
        <div class="col">
            <p><i class="fas fa-exclamation-triangle"></i>
            A prioridade para consumo do limite de stop loss se dará de acordo com a ordem das solicitações abaixo estabelecida.</p>
        </div>
        <div class="col-auto" >
            <button class="btn btn-primary" type="button" (click)="obterRepriorizacao()"
            ngbTooltip="Prioridade"><i class="fa fa-level-up"></i> Repriorizar lote </button>
            <button class="btn btn-primary" type="button" (click)="inclui()"
            ngbTooltip="Incluir"><i class="fa fa-plus-circle"></i> Nova solicitação</button>
        </div>
    </div>
</div>
<div class="container" *ngIf="solicitacoesHonra && solicitacoesHonra.length">
    <bn-paginacao [total]="atributosPaginacaoComponenteListagem.count"
    [tamanhoPagina]="atributosPaginacaoComponenteListagem.pageSize" [numPagina]="atributosPaginacaoComponenteListagem.page"
    [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
      <div class="table-responsive"><table class="table table-hover">
        <thead><tr>
            <th scope="col">Nº</th>
            <th scope="col" id="col-idOperacaoExterno">Id. externo operação</th>
            <th scope="col" id="col-sistema-contrato">Sist./Contrato</th>
            <th scope="col" id="col-dataParcelaInicialASerHonrada">1&ordf; parcela honrada</th>
            <th scope="col" id="col-valorEstimadoHonra" class="text-end">Valor estimado</th>
            <th scope="col" id="col-obs">Observação</th>
            <th scope="col" id="col-acoes" class="text-center">ações</th> <!--ações-->
        </tr></thead>
        <tbody><tr *ngFor="let solicitacaoHonra of solicitacoesHonra; let i = index">
            <td><span>{{ i+1 }}</span></td>
            <td>{{ solicitacaoHonra.idOperacaoExterno }}</td>
            <td>{{ solicitacaoHonra.contratoRepasse ? solicitacaoHonra.sistemaRepasse + '/' + solicitacaoHonra.contratoRepasse : ''}}</td>
            <td>{{ solicitacaoHonra.dataParcelaInicialASerHonrada ? (solicitacaoHonra.dataParcelaInicialASerHonrada | date: 'dd/MM/yyyy') : 'N.A.'}}</td>
            <td class="text-end">{{ solicitacaoHonra.valorEstimadoHonra | bnMask: 'MOEDA'}}</td>
            <td>{{ solicitacaoHonra.estado.motivoEstado }}</td>
            <td class="text-center">
                <a href="javascript:void(0)" (click)="altera(solicitacaoHonra, i)">
                    <i class="fa fa-pencil" aria-hidden="true" placement="left-top" ngbTooltip="Editar"> </i></a>
                <a href="javascript:void(0)" (click)="exclui(solicitacaoHonra, i)">
                    <i class="fa fa-trash margin-left-5"  aria-hidden="true" placement="left-top" ngbTooltip="Excluir"></i></a>
            </td>
        </tr></tbody>
      </table></div>
    </bn-paginacao>
</div>

<ng-template #formularioModalBotoes >
    <button (click)="modalService.dismiss(acaoCorrente.label)" class="btn" [ngClass]="!excluindo && formulario.pristine ? 'btn-primary' : 'btn-danger'">Cancelar</button>
    <button (click)="confirma()" class="btn btn-primary" *ngIf="podeMostrarConfirmar()"
        [disabled]="!excluindo && ((formulario.pristine && amortizacoesAteADataDaSolicitacaoDeHonra.pristine) || !formulario.valid)">Confirmar</button>
</ng-template>

<ng-template #formularioModal>
<div class="col">
    <p>
    Atenção: A nova solicitação de honra irá compor o lote de solicitações de honra desta janela (juntamente com as solicitações enviadas anteriormente).
    <br/><br/>
    As validações realizadas pelo sistema são sempre aplicadas a todas as solicitações da mesma janela.
    </p>

    <div class="opcoes" *ngIf="!excluindo && utilizaTaxaAtualizacaoGarantia && !ehModalidadeFGT" >
        <div class="row">

            <div class="col-sm-12" style="margin-bottom: 10px;">
               Escolha uma das opeções a seguir:
            </div>
           <div class="col-sm-12 opcao">
             <input type="radio" value="semAtualizacao" [checked]="semAtualizacao" [disabled]="alterando" name="opcaoEnvio" (change) ="validarOpcaoAtualizacao($event.target.value)"> Solicitação de honra sem atualização da garantia
           </div>
           <div class="col-sm-12 opcao">
             <input type="radio" value="comAtualizacao" [checked]="semAtualizacao === false" [disabled]="alterando" name="opcaoEnvio" (change) ="validarOpcaoAtualizacao($event.target.value)"> Solicitação de honra com atualização da garantia
           </div>
      </div>
    </div>
</div>

<form [formGroup]="formulario" class="form">
    <ul ngbNav #nav="ngbNav" class="col nav-tabs">

    <li [ngbNavItem]="'principal'" title="Principal" title="Principal">
      <button ngbNavLink>Principal</button>
      <ng-template ngbNavContent>
        <div class="row" >
          <div class="bn-form-group col-md-2">
              <label class="form-label" for="prioridade"><b>Nº Ordem <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                  ngbTooltip="prioridade desta solicitção para o consumo de stop loss."></i></b></label>
              <input type="text" class="form-control" formControlName="prioridade" >
          </div>
          <div class="bn-form-group col-md-3">
              <label class="form-label" for="sistema"><b>Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i></b>
              </label>
              <select class="form-select" formControlName="sistema">
                <option value='CL'>Crédito Livre</option>
                <option value='15'>15 - FINAME</option>
                <option value='89'>89 - BNDES</option>
              </select>
          </div>
          <div class="bn-form-group col-md-4">
              <label class="form-label">Id. externo operação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                ngbTooltip="Identificador da operação informado pelo Agente Financeiro em operações de Crédito Livre."></i>
              </label>
              <input type="text" class="form-control" formControlName="idOperacaoAgenteCreditoLivre" >
          </div>

          <div class="bn-form-group col-md-3">
              <label class="form-label">Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
              </label>
              <input type="text" class="form-control" formControlName="contrato" >
          </div>
        </div>

        <div class="row" >
          <div class="bn-form-group col-md-4">
              <label class="form-label"><b>Saldo devedor de principal:</b></label>
              <input type="text" class="form-control moeda" formControlName="valorSaldoDevedorDePrincipal" bnMask="MOEDA" />
          </div>
          <div class="bn-form-group col-md-4">
              <label class="form-label"><b>Saldo de juros na normalidade:</b></label>
              <input type="text" class="form-control moeda" formControlName="valorSaldoDeJurosNaNormalidade" bnMask="MOEDA"/>
          </div>
          <div class="bn-form-group col-md-4">
              <label class="form-label"><b>Saldo Encargos moratórios:</b></label>
              <input type="text" class="form-control moeda" formControlName="valorEncargosMoratorios" bnMask="MOEDA"/>
          </div>
        </div>
         <div class="row" >
          <div class="bn-form-group col-md-4">
            <label class="form-label">
              <b>Possui bloqueio judicial? </b>
              <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                ngbTooltip="Informar caso exista processo judicial associado a operação sendo honrada"></i>
            </label>
            <input type="checkbox" class="form-check checkbox-gigante" name="possuiBloqueioJudicial"
              ngDefaultControl formControlName="possuiBloqueioJudicial">
          </div>
          <div class="bn-form-group col-md-8">
            <label class="form-label">
              <b>Número do processo: </b>
              <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                ngbTooltip="Número do processo judicial associado ao Bloqueio. Somente serão aceitos processos a partir do ano de 2020"></i>
            </label>
            <input type="text" class="form-control" [bnMask]="bnMaskNumeroProcesso"
              formControlName="numeroProcesso"/>
            <small class="text-danger" *ngIf="anoAjuizamentoNumeroProcessoInvalido() || formatoNumeroProcessoInvalido()">Número do processo em formato inválido, serão aceitos processos a partir de 2020 e devem seguir a formatação: NNNNNNN-DD.AAAA.J.TR.OOOO</small>
          </div>
        </div>
      </ng-template>
    </li>

    <li [ngbNavItem]="'fluxo-amortizações-ocorridas'" title="Fluxo Amortizações Ocorridas" *ngIf="!excluindo && semAtualizacao != null" >
        <button ngbNavLink>Fluxo Amortizações Ocorridas</button>
        <ng-template ngbNavContent >
        <a (click)="adicionarAmortizacao()"><i class="fa fa-plus-circle cursor-pointer"></i></a>

        <div class="table-responsive h260-ov-y-auto">
        <table class="table table-sm">
            <thead > <tr>
                <th scope="col" class="width-4-perc">Nº</th>
                <th scope="col" class="width-27-perc">Data do vencimento *</th>
                <th scope="col" class="width-30-perc" class="text-end">Valor devido *</th>
                <th *ngIf="semAtualizacao" scope="col" class="width-30-perc" class="text-end">Valor recebido *</th>
                <th scope="col" class="width-4-perc"></th>
            <tr> </thead>
            <tbody ><tr *ngFor="let amort of amortizacoesAteADataDaSolicitacaoDeHonra.controls; let i = index">
            <ng-container [formGroup]="amort">
                <td><span >{{ i+1 }}</span></td>
                <td><bn-datepicker formControlName="dataVencimento" idInput="dataVencimento" name="dataVencimento"></bn-datepicker></td>
                <td><input         formControlName="valorDevido" class="form-control text-end" bnMask="MOEDA"></td>
                <td *ngIf="semAtualizacao"><input         formControlName="valorRecebido" class="form-control text-end" bnMask="MOEDA"></td>
                <td><span ><a (click)="removerAmortizacao (i)"><i class="fa fa-trash cursor-pointer" ></i></a></span></td>
            </ng-container></tr></tbody>
        </table>
        </div></ng-template>
    </li>

    <li [ngbNavItem] title="Informe de recebimentos" *ngIf="!excluindo && semAtualizacao === false">
        <button ngbNavLink>Informe de recebimentos</button>
        <ng-template ngbNavContent *ngIf="!excluindo && semAtualizacao === false">
            <div class="bn-form-group col-md-4">
                <label class="form-label"><b>Data início da inadimplencia:</b></label>
                <bn-datepicker formControlName="dataInicioInadimplencia" idInput="dataInicioInadimplencia" name="dataInicioInadimplencia"></bn-datepicker>
            </div>

        <a (click)="adicionarValoreAReceber()"><i class="fa fa-plus-circle cursor-pointer"></i></a>

        <div class="table-responsive h260-ov-y-auto">
        <table class="table table-sm">
            <thead > <tr>
                <th scope="col" class="width-4-perc">Nº</th>
                <th scope="col" class="width-27-perc">Data do recebimento *</th>
                <th scope="col" class="width-30-perc" class="text-end">Valor recebido *</th>
                <th scope="col" class="width-4-perc"></th>
            <tr> </thead>
            <tbody ><tr *ngFor="let amort of valoresRecebidos.controls; let i = index">
            <ng-container [formGroup]="amort">
                <td><span >{{ i+1 }}</span></td>
                <td><bn-datepicker formControlName="dataRecebimento" idInput="dataRecebimento" name="dataRecebimento"></bn-datepicker></td>
                <td><input         formControlName="valorRecebido"  class="form-control text-end" bnMask="MOEDA"></td>
                <td><span ><a (click)="removerValoreAReceber(i)"><i class="fa fa-trash cursor-pointer" ></i></a></span></td>
            </ng-container></tr></tbody>
        </table>
        </div></ng-template>
    </li>

    </ul>

    <div [ngbNavOutlet]="nav" class="mt-2"></div>

    <div class="container row" *ngIf="acaoCorrente.ocorrencias?.length > 0">
        <div class="table-responsive">
            <table class="table-striped table-bordered">
                <thead>
                    <tr>
                        <th class="text-center">
                            Identificador
                          </th>
                        <th class="text-center">Erro(s) encontrado(s)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ocorrencia of acaoCorrente.ocorrencias">
                        <td width="20%">
                            {{ ocorrencia.idObjetoValidado }}
                        </td>
                        <td width="80%" class="mensagem-erro">
                            {{ formatarMensagem(ocorrencia.mensagem) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</form>
</ng-template>

<ng-template #prioridadeModalBotoes >
    <button class="btn btn-danger" (click)="modalService.dismiss('desistiu da repriorização')" >Cancelar</button>
    <button class="btn btn-primary" (click)="confirmarRepriorizacao()">Confirmar</button>
</ng-template>

<ng-template #prioridadeModal>
    <app-solicitacao-honra-prioridade
        [protocoloSHs]="protocoloSHsValidoJanelaAtual"
        [acaoPriorizacao]="acaoModalPriorizacao"
        [ocorrenciasCadastroSH]="ocorrenciasPriorizacao"
        (aoConfirmarRepriorizacao)="submeterRepriorizacao ($event)"
    >
    </app-solicitacao-honra-prioridade>
</ng-template>



